/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useFormController from '../hooks/useFormController';
import formControllerState from '../utils/formControllerState';

const FormStatusMessage = (props) => {
  const {
    children,
    id
  } = props;

  const formControl = useFormController();
  const fcs = formControllerState({
    props,
    formControl,
    states: ['status', 'disabled']
  });

  if (children === undefined || fcs.status === undefined) return null;

  const descriptionClasses = classNames('sui-font-regular sui-mt-1 sui-text-xs sui-leading-none sui-text-left', {
    'sui-text-inactive': fcs.disabled && !fcs.status,
    'sui-text-danger': fcs.status === 'error',
    'sui-text-success': fcs.status === 'success',
    'sui-text-primary': fcs.status === 'warning'
  });

  return (
    <p className={descriptionClasses} id={id}>
      {children}
    </p>
  );
};

FormStatusMessage.displayName = 'FormStatusMessage';

FormStatusMessage.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  status: PropTypes.oneOf(['error', 'success', 'warning'])
};

FormStatusMessage.defaultProps = {};

export { FormStatusMessage };
